export default __webpack_public_path__ + "static/media/ic_manage-product-device.4cb3380a.svg";